/**
 * TXIPROCEDURETYPE enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file TXIPROCEDURETYPE.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum TXIPROCEDURETYPE {
  'NONE'= 0,
  'CYCLE'= 1,
  'WATER'= 2,
  'RANDOM'= 3,
  'RINGTEXDISTORT'= 4
};